import React from "react";
import BarraSupDent from "../../../commons/BarraSupDent";
import Title from "../../../pages/Login/Components/title/title";
import "../CancelJob/cancelJob.css";
import AddButton from "../../../commons/AddButton";
import NavbarTechnician from "../../../commons/NavbarTechnician";
import { Link } from "react-router-dom";
import firebaseManager from "../../../model/Firebase/FirebaseManager";

class CancelJob extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      reasons: "",
    };
  }

  handleChange(e) {
    this.setState({
      reasons: e.target.value,
    });
  }

  handleClick(e) {
    e.preventDefault();
    if (this.state.reasons === "") {
      document.getElementById("alertCancel").classList.remove("d-none");
    } else {
      firebaseManager.listOfReasons(
        this.state.reasons,
        this.successListReasons,
        this.failListReasons
      );
    }
  }

  successListReasons = () => {
    window.location = "/homeTechnician";
  };

  failListReasons(error) {}
  render() {
    return (
      <React.Fragment>
        <BarraSupDent />
        <div id="alertCancel" class="alert alert-danger d-none" role="alert">
          <p className="text-center">Please, complete with your reasons.</p>
        </div>
        <Title text1="Are you sure? You can only cancel for the following reasons" />
        <div className="text-center  pb-5">
          <textarea
            className="form-control sizeTextAreaReasons mx-auto mt-5 mb-5"
            id="reasons"
            name="reasons"
            placeholder="What happened? *required"
            onChange={this.handleChange}
            value={this.state.reasons}
          ></textarea>
          <Link to="/job_in_progress">
            <AddButton text="Go back" />
          </Link>
          <div className="mb-5">
            <button
              onClick={this.handleClick}
              className="btn cancelButton mb-5 mt-1"
            >
              CANCEL JOB
            </button>
          </div>
        </div>
        <NavbarTechnician />
      </React.Fragment>
    );
  }
}
export default CancelJob;
